module.exports = __webpack_public_path__ + "img/logo.e46260c0.png";